import React, { useEffect, useState } from 'react';
import Beyond from '@/assets/images/beyond-2g.png';
import AudioFormat from '@/assets/images/audio-format-right.png';
import ThousandSite from '@/assets/images/thousand-site.png';
import sendGaEvent from '@/ga';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import './index.less';
import Cookies from 'js-cookie';

export default function Beyond2G(props) {
  const [advertiseType, setAdvertiseType] = useState(1);
  const { t } = useTranslation(['advertise']);

  const downloadDesktop = () => {
    sendGaEvent({
      category: 'vc_referral',
      action:
        advertiseType == 1
          ? 'AudioExtractor_FloatingSizeDownload'
          : advertiseType == 2
          ? 'AudioExtractor_FloatingFasterDownload'
          : 'AudioExtractor_FloatingFormatsDownload',
    });
    props.downloadDesktop();
  };

  useEffect(() => {
    let boardType = Cookies.get('advertiseType') || 1;
    console.log(+boardType);
    setAdvertiseType(+boardType);
    if (+boardType + 1 <= 3) {
      console.log(+boardType + 1);
      Cookies.set('advertiseType', +boardType + 1);
    } else {
      Cookies.set('advertiseType', 1);
    }
  }, []);
  return (
    <div className='beyondContent'>
      <div className='headImage'>
        {advertiseType == 1 ? (
          <img src={Beyond} className='beyondHeader' />
        ) : advertiseType == 2 ? (
          <img src={ThousandSite} className='beyondHeader' />
        ) : advertiseType == 3 ? (
          <img src={AudioFormat} className='beyondHeader' />
        ) : (
          ''
        )}
      </div>
      <div className='description'>
        {advertiseType == 1 ? (
          <div>
            <span> {t('BachFileNoLimit')}</span>
          </div>
        ) : advertiseType == 2 ? (
          <div>{t('120XDownloadSites')}</div>
        ) : advertiseType == 3 ? (
          <div>{t('ConvertVideoTo300Formats')}</div>
        ) : (
          ''
        )}
      </div>
      <div className='btnContainer'>
        <button onClick={() => downloadDesktop()} className='freeDownload'>
          {t('Try It Free')}
        </button>
      </div>
    </div>
  );
}
